import 'css-chunksrc/feature/check-discount/CheckPanelDiscounts.module.scss';export default {
  "root": "CheckPanelDiscounts_root",
  "item": "CheckPanelDiscounts_item",
  "icon": "CheckPanelDiscounts_icon",
  "grid": "CheckPanelDiscounts_grid"
};